import React, { FC, useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { SignUpSectionContainer, SignUpFormContainer } from './style'
import FormInputField from 'components/FormInputField'
import Checkbox from 'components/Checkbox'
import StyledButton from 'components/Button'
import { useRecoilState } from 'recoil'
import {
  termsOfServiceState,
  termsOfServiceErrorState,
} from 'states/CheckOutStates/atoms';
import { colors } from 'constants/colors'
import { useAuth } from 'customHooks/useAuth'
import { useMutation } from '@apollo/client';
import { SIGN_UP } from 'graphql/service';
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';

import {
  GoogleLogo,
} from 'assets/icons';

const SignUpSection: FC = () => {

  const { showGlobalError, showGlobalMessage } = useGlobalAlerts();

  const history = useHistory()
  const { validToken } = useAuth()
  // Only redirect users who were already signed in when this screen opened.
  const initialValidToken = useRef(validToken)

  const [termsOfServiceError, setTermsOfServiceError] = useRecoilState(termsOfServiceErrorState)
  const [termsOfServiceChecked, setTermsOfServiceChecked] = useRecoilState(termsOfServiceState)

  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState(false)
  const [fullName, setFullName] = useState('')
  const [fullNameError, setFullNameError] = useState(false)

  const [signUp] = useMutation(
    SIGN_UP,
    {
      // onCompleted: (signUpData) => {
      //   if(signUpData.signupTenantBasic?.id) {
      //     showGlobalMessage('Sign up successful! Please check your email to verify your account.');
      //     console.log('Sign up successful! Please check your email to verify your account.')
      //     history.push('/sign-up-confirm', {
      //       originalEmail: email,
      //     })
      //   }
      // },

      onCompleted: (signUpData) => {
        const result = signUpData.signupTenantBasic

        if (result?.emailResetToken) {
          showGlobalMessage(
            'Sign up successful! Please check your email to verify your account.'
          )

          history.push('/sign-up-confirm', {
            originalEmail: result.email,
            resetToken: result.emailResetToken,
          })
        }
      },
      onError(error) {
        const content = error.message
        console.log(content)
        showGlobalError(content)
      }
    }
  )

  useEffect(() => {
    if (initialValidToken.current) {
      history.push('/')
    }
  }, [history])


  // Google login 

  const base64UrlEncode = (arrayBuffer: ArrayBuffer) => {
    const bytes = new Uint8Array(arrayBuffer)
    let binary = ''
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    const base64 = btoa(binary)
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')
  }

  const createCodeVerifier = (length = 64) => {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'
    const bytes = new Uint8Array(length)
    window.crypto.getRandomValues(bytes)
    let result = ''
    for (let i = 0; i < bytes.length; i++) {
      result += charset[bytes[i] % charset.length]
    }
    return result
  }

  const createState = () => {
    const bytes = new Uint8Array(16)
    window.crypto.getRandomValues(bytes)
    return Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('')
  }

  const handleGoogleLogin = async () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID

    if (!clientId) {
      showGlobalError('Missing REACT_APP_GOOGLE_CLIENT_ID')
      return
    }

    //const redirectUri = `${window.location.origin}/auth/callback`
    const redirectUri = `${window.location.origin}/auth/callback/google`
    const state = createState()

    const codeVerifier = createCodeVerifier(64)
    const digest = await window.crypto.subtle.digest(
      'SHA-256',
      new TextEncoder().encode(codeVerifier)
    )
    const codeChallenge = base64UrlEncode(digest)

    sessionStorage.setItem('oauth_provider', 'GOOGLE')
    sessionStorage.setItem('oauth_state', state)
    sessionStorage.setItem('pkce_verifier_GOOGLE', codeVerifier)

    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: 'code',
      scope: 'openid email profile',
      state,
      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      prompt: 'select_account',
    })

    window.location.href =
      `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`
  }

  // Google login 


  const handleSignUp = () => {
    let result = true

    if (!termsOfServiceChecked) {
      setTermsOfServiceError(true)
      result = false
      //return
    } else {
      if (termsOfServiceError) {
        setTermsOfServiceError(false)
      }
    }

    if (fullName.length < 3) {
      setFullNameError(true)
      result = false
    } else {
      if (fullNameError) {
        setFullNameError(false)
      }
    }

    if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setEmailError(true)
      result = false
    } else {
      if (emailError) {
        setEmailError(false)
      }
    }

    if (result) {
      signUp({
        variables: {
          data: {
            fullName,
            email
          }
        }
      })
    } else {
      const content = 'Please fill in all required fields and try again.'
      console.log(content)
    }
  }

  return (
    <SignUpSectionContainer>
      <div className="innerContainer">
        <SignUpFormContainer>
          <div className="container">
            <div className="formTitle">Sign up</div>
            <div className="inputFieldContainer">
              <FormInputField
                label="FULL NAME"
                isRequired
                inputHeight="48px"
                borderColor={colors.signInBorderColor}
                marginBottom="16px"
                placeholder="Full Name"
                labelWeight="400"
                value={fullName}
                error={fullNameError}
                errorMessage='Please enter your full name'
                onChange={(e) => {
                  setFullName(e.target.value)
                  if (fullNameError) {
                    setFullNameError(false)
                  }
                }}
              />
              <FormInputField
                label="EMAIL"
                isRequired
                inputHeight="48px"
                borderColor={colors.signInBorderColor}
                marginBottom="16px"
                placeholder="User Email"
                labelWeight="400"
                value={email}
                error={emailError}
                errorMessage='Please enter a valid email address'
                onChange={(e) => {
                  setEmail(e.target.value)
                  if (emailError) {
                    setEmailError(false)
                  }
                }}
              />
              <div className='termsOfServiceContainer'>
                <div className='termsOfService'>
                  <Checkbox
                    checked={termsOfServiceChecked}
                    error={termsOfServiceError}
                    borderColor={colors.signInBorderColor}
                    onChange={() => {
                      setTermsOfServiceChecked(!termsOfServiceChecked)
                      localStorage.setItem('termsOfServiceChecked', (!termsOfServiceChecked).toString())
                      setTermsOfServiceError(false)
                    }}
                    checkboxScale={1.5}
                  />
                  <div className='text'>
                    <span className='plainText'>I agree to Rook Hotel's </span>
                    <span
                      className="tips"
                      onClick={() => {
                        history.push('/terms-and-conditions')
                      }}
                    >
                      Terms of Service
                    </span>
                    <span className='required'> *</span>
                  </div>
                </div>
                {termsOfServiceError ? <div className='required'>Please agree to our Terms of Service to proceed.</div> : null}
              </div>
            </div>
            <div className="buttonContainer">
              <StyledButton
                width="111px"
                height="48px"
                fontSize={16}
                onClick={handleSignUp}
              >
                Sign up
              </StyledButton>
              <div className='dividerContainer'>
                <hr className="divider" />
                <span>or</span>
                <hr className="divider" />
              </div>

            </div>
          </div>
          <div className="socialLogin">
            <div className="socialButton" onClick={handleGoogleLogin}>
              <GoogleLogo /> Continue with Google
            </div>            



            {/* <div className="socialButton" onClick={handleAppleLogin}>
              <AppleLogo /> Continue with Apple
            </div>
            <div className="socialButton" onClick={handleXLogin}>
              <XLogo /> Continue with Twitter
            </div>
            <div className="socialButton" onClick={handleFacebookLogin}>
              <MetaLogo /> Continue with Facebook
            </div> */}

          </div>
          <div className="signInBox">
            <span>Already have an account? </span>
            <span
              className="tips"
              onClick={() => {
                history.push('/sign-in')
              }}
            >
              Sign in
            </span>
          </div>
        </SignUpFormContainer>
      </div>
    </SignUpSectionContainer>
  );
};

export default SignUpSection;
